import ApiService from "@/common/api.service"

export const UniversitiesService = {
    create(params) {
        return ApiService.post("universities/add", params);
    },
    update(slug, params) {
        return ApiService.update("universities", slug, params);
    },

}